const AdminPage = () => {
    return <div className="p-6 bg-gray-100 min-h-screen"></div>;
};

export default AdminPage;
